export const races = [
	'Native American',
	'Black / African',
	'Asian',
	'Caucasian',
	'Latino/Hispanic',
	'Pacific Islander',
	'Multi-racial',
	'Prefer not to answer',
	'Prefer to self-describe'
];

export const genderIdentities = [
	'Cisgender Female',
	'Cisgender Male',
	'Transgender Female',
	'Transgender Male',
	'Genderqueer or Gender Fluid',
	'Questioning or unsure',
	'Gender identity not listed',
	'Prefer not to answer',
];

export const sexualPreference = [
	'Heterosexual (straight)',
	'Bisexual',
	'Gay',
	'Lesbian',
	'Pansexual',
	'Asexual',
	'Queer',
	'Questioning or Unsure',
	'Prefer not to answer',
	'Prefer to self-describe'
];

export const relationshipStatuses = [
	'Single',
	'Dating',
	'Open relationship',
	'In committed relationship',
	'Multiple Partners',
	'Living together',
	'Engaged',
	'Widow',
	'Married',
	'Remarried',
	'Divorced / Separated',
	'Prefer not to answer',
];

export const contraceptiveMethods = [
	'Partner Vasectomy',
	'Mirena',
	'Skyla',
	'Liletta',
	'Kyleena',
	'Pullout Method',
	'Nexplanon',
	'Depo-Provera Shot',
	'Vaginal Ring',
	'Vaginal Gel',
	'Paragard (non-hormonal IUD)',
	'Oral Contraceptive Pills',
	'Patch',
	'Condoms',
	'Tubal Ligation',
	'Fertility Awareness',
	'Abstinence',
	'No Method',
	'Implant',
	'IUD',
	'IUD - Nonhormonal',
	'IUD - Hormonal'
].sort();

export const fertilityPreservationMethods = [
	'Embryo freeze',
	'Oocyte cryopreservation',
	'Egg freezing',
	'Ovarian cryopreservation',
	'Ovarian transposition',
	'More conservative surgery',
	'Ovarian suppression (GnRh agonist)',
	'Ovarian suppression (oral contraceptive pills)',
	'Other'
].sort();

export const fertilityTreatments = [
	'In Vitro Fertilization (IVF)',
	'Reproductive Surgery: Endometriosis',
	'Ovum Donor Program',
	'Donor Sperm Insemination',
	'Embryo, Semen and Oocyte Cryopreservation',
	'Gestational Surrogacy',
	'Intracytoplasmic Sperm Injection (ICSI)',
	'Male Reproductive Laboratory',
	'Pre-Implantation Genetic Diagnosis (PGD)',
	'Tubal Ligation Reversals',
	'Partner Sperm Insemination'
].sort();

export const sitesOfCancer = [
	"Bone",
	"Brain",
	"Breast",
	"Endocrine",
	"Ovarian",
	"Pancreatic",
	"Renal or kidney",
	"Other GU",
	"Colon or rectal",
	"Gastric or stomach",
	"Other GI",
	"Endometrial (uterine)",
	"Other gynecologic",
	"Head and Neck",
	"Leukemia",
	"Lung",
	"Lymphoma",
	"Melanoma",
	"Uterus", 
	"Stomach",
	'Anal',
	'Cervical',
	'Oropharyngeal (throat)',
	'Penile',
	'Vulvar',
	'Bladder',
	'Metastatic',
	'Skin'
].sort();

export const cancerTreatments = [
	"Chemotherapy",
	"Radiation Therapy",
	"Adjuvant Therapy",
	"Surgery",
	"Immunotherapy",
	"Hormonal Therapy"
].sort();

export const reproductiveLifeJourneyPositions = [
	"Not Yet",
	"I'm Ready",
	"I'm In It",
	"I'm Done",
	"Not Interested"
];

export const recommentedTo = [
	"Colleagues",
	"Sisters",
	"Mothers",
	"Partners",
	"Daughters",
	"Friends,Any Young Women",
	"College aged women",
	"Professional women",
	"Other"
];

export const featuresOrOptionsApp = [
	"Dating advice",
	"Pap smear tracking / Cancer prevention",
	"Period Tracking",
	"Fertility Tracking",
	"Guidance on Products for Your Stage of the Reproductive Life Journey",
	"Financial Planning",
	"Education Planning", "Sharing with health provider",
	"Other"
];

export const featuresOrOptionsWebsite = [
	"Online Reproductive Life Coach",
	"Telemedicine",
	"Education / Articles on Reproductive Life Issues",
	"Other",
];

export const feedbackIam = [
	"Navigating my own reproductive life journey",
	"A care provider",
	"A managed care leader",
	"A thought leader",
	"A women's health advocate",
	"Other"
]

export const generalDiseases = [
	"Cholesterol",
	"Diabetes",
	"Heart Disease",
	"Hypertension",
	"Stroke"
]

export const behavioralDiseases = [
	"Alcohol Use",
	"Tobacco Use",
	"Drug Use"
]

export const cardiovascularDiseases = [
	"Acute myocardial infarction",
	"Cardiac arrest",
	"Cardiac arrhythmia",
	"Congenital heart disease",
	"Coronary artery disease",
	"Heart Failure",
	"Hyperlipidemia",
	"Hypertension",
	"Mitral valve disorder",
	"Peripheral vascular"
]

export const endocrineDiseases = [
	"Diabetes mellitus type 1",
	"Diabetes mellitus type 2",
	"Diabetes mellitus type 2",
	"Non-insulin-dependent",
	"Hyperglycemia",
	"Hyperthyroidism",
	"Hypoglycemia",
	"Hypothyroidism"
]

export const gastrointestinalDiseases = [
	"Crohn's disease",
	"Diverticulitis",
	"Hepatitis A",
	"Hepatitis B",
	"Hepatitis C",
	"Ulcerative colitis",
	"IBS-D (Diarrhea)",
	"IBS-C (Constipation)"
]

export const hematologicDiseases = [
	"Anemia",
	"Clotting disorder",
	"Sickle cell disease"
]

export const immunologicDiseases = [
	"Autoimmune disease",
	"HIV (human immunodeficiency virus infection)",
	"Lupus",
	"Rheumatoid aortitis"
]

export const neurologicDiseases = [
	"Alzheimers disease",
	"Dementia",
	"Migraine",
	"Multiple sclerosis",
	"Seizure",
	"Stroke",
	"TIA (transient ischaemic attack)"
]

export const oncologicDiseases = [
	"Bone",
	"Brain",
	"Breast",
	"Endocrine",
	"Ovarian",
	"Pancreatic",
	"Renal or kidney",
	"Other GU",
	"Colon or rectal",
	"Gastric or stomach",
	"Other GI",
	"Endometrial (uterine)",
	"Cervical",
	"Other gynecologic",
	"Head and Neck",
	"Leukemia",
	"Lung",
	"Lymphoma",
	"Melanoma",
	"Uterus", 
	"Stomach",
	'Anal',
	'Oropharyngeal (throat)',
	'Penile',
	'Vulvar',
	'Bladder',
	'Metastatic',
	'Skin'
].sort()

export const psychiatricDiseases = [
	"Anxiety",
	"Bipolar disorder",
	"Depression",
	"Schizophrenia"
]

export const respiratoryDiseases = [
	"Asthma",
	"COPD (chronic obstructive pulmonary disorder)",
	"Cystic fibrosis",
	"Pneumonia",
	"Sleep apnea"
]

export const reproductiveDiseases = [
	"Hashimotos",
	"Endometriosis",
	"Fibroids",
	"PCOS"
]

export const familyHeirs = [
	"None",
	"Mother",
	"Father",
	"Sister",
	"Brother",
	"Maternal Aunt",
	"Maternal Uncle",
	"Paternal Aunt",
	"Paternal Uncle",
	"Maternal Grandparent",
	"Paternal Grandparent",
	"Maternal Cousin",
	"Paternal Cousin"
]

export const thermostat = [
	"I am happy and right where I want to be with my goals.",
	"I am feeling good about my goals and close to where I want to be.",
	"Looking to make a few changes, but feeling okay.",
	"I am not satisfied with my current goals and plan.",
	"Other"
];

export const menopauseStatus = [
	"Premenopausal", "Perimenopausal", "Menopause", "Postmenopausal"
]

export const menopauseReasons = [
	"Both uterus and ovaries removed",
	"Chemotherapy",
	"Natural menopause",
	"Ovaries removed (oophorectomy)",
	"Uterus removed (hysterectomy)",
	"Unknown",
	"None"
]

export const menopauseSymptons = [
	"Irregular periods",
	"Hot flashes",
	"Night sweats",
	"Breast tenderness",
	"Headaches",
	"Irritability",
	"Sleep difficulties",
	"Exhausted",
	"Mood changes",
	"Anxiety",
	"Forgetful",
	"Fuzzy-minded",
	"Bloating",
	"Low sexual desire"
]
export const geneticTestingTypes = [
	"Carrier screening",
	"Cancer genetic testing",
	"23 and Me",
	"Other"
]

export const geneticCancerGene = [
	"I’m not sure",
	"BRCA1",
	"BRCA2",
	"MLH1(Lynch syndrome)",
	"MSH2(Lynch syndrome)",
	"MSH6(Lynch syndrome)",
	"PMS2(Lynch syndrome)",
	"EPCAM(Lynch syndrome)",
	"PALB2",
	"ATM",
	"CHEK2",
	"RAD51C",
	"RAD51D",
	"PTEN",
	"APC",
	"TP53",
	"NF1",
	"BRIP1",
	"Other",
]


export const  interestItems = [
    {
      id: 0,
      item: "Setting my reproductive life plan",
    },
    {
      id: 1,
      item: "Tracking my birth control",
    },
    {
      id: 2,
      item: "Logging my menopause status",
    },
    {
      id: 3,
      item: "Engaging with my fertility journey",
    },
    {
      id: 4,
      item: "Creating my family planning goals",
    },
    {
      id: 5,
      item: "Logging my pregnancies ",
    },
    {
      id: 6,
      item: "Recording my cancer treatment",
    },
	{
		id: 7,
		item: "Sexual health education",
	},
	{
		id: 8,
		item: "Tracking my pap smears",
	},
	{
		id: 9,
		item: "Connecting with my Paptrak",
	},
  ];

export const checkInList = [
    {
      id: 0,
      item: "I am just stopping by, I am exactly where I want to be with my goals.",
    },
    {
      id: 1,
      item: "Here to update my Paptrak, new  pap smear results.",
    },
    {
      id: 2,
      item: "There is changes to my reproductive health, doing a RepLI check in.",
    },
    {
      id: 3,
      item: "I feel unsure about  with my current birth control use.",
    },
    {
      id: 4,
      item: "I am ready to start a new birth control method that works for me.",
    },
    {
      id: 5,
      item: "I am unsure,  I might be transitioning into my menopause era.",
    },
    {
      id: 6,
      item: "I want to grow my family and desire to become pregnant.",
    },
	{
		id: 7,
		item: "Stopping by for some health resources and information.",
	},
	{
		id: 8,
		item: "Here to update my cancer diagnosis and treatment log.",
	},
	{
		id: 9,
		item: "I want to update my profile, it's been a while.",
	}

  ];


  export const department= [ 'Family Planning Clinic', 'Adolescent Clinic',	'Family Medicine', 'Gynecology',
	'Reproductive Health Services',	'Obstetrics', 'Bariatrics']

export const obesityMedications=['Phentramine',
	"Buproprion-naltrexone(Contrave)",
	'Liraglutide (Sexenda)',
	'Orlistat (Xenical, Atti)',
	'Phentramine-topiramate (Qsymia)',
	'Tirzepatide (Mounjaro/Zepbound)' ,
	'Semaglutide (Wegový)',
	'Setmelanotide (Imclvree)'
].sort()
 
export const typeOfPreviousSurgery =[
	'Lap Band',
	'Sleeve gastrectomy',
	'Gastric bypass',
	'SADI',
	'Duodental switch',
	'Bariatric revision surgery'
]

